import SummaryVuzSvodView from '../views/SummaryVuzSvodView.vue';
import {createRouter, createWebHistory} from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import authService from "../services/authService";
import WelcomeView from "@/views/WelcomeView.vue";
import DictionariesView from "@/views/DictionariesView.vue";
import UniversitiesView from "@/views/dictionary/UniversitiesView.vue";
import DegreesView from "@/views/dictionary/DegreesView.vue";
import RegionsView from "@/views/dictionary/RegionsView.vue";
import RegionView from "@/views/dictionary/RegionView.vue";
import UniversityView from "@/views/dictionary/UniversityView.vue";
import DegreeView from "@/views/dictionary/DegreeView.vue";
import ProfessionsView from "@/views/dictionary/ProfessionsView.vue";
import ProfessionView from "@/views/dictionary/ProfessionView.vue";
import UsersView from "@/views/UsersView.vue";
import UserView from "@/views/UserView.vue";
import StudentsView from "@/views/StudentsView.vue";
import StudentView from "@/views/StudentView.vue";
import ProfessionsCostView from "@/views/dictionary/ProfessionsCostView.vue";
import ProfessionCostView from "@/views/dictionary/ProfessionCostView.vue";
import CitizenshipsView from "@/views/dictionary/CitizenshipsView.vue";
import AccessDenied from "@/views/AccessDenied.vue";
import SettingsView from "@/views/SettingsView.vue";
import StudentsCreditsView from "@/views/StudentsCreditsView.vue";
import StudentCreditsView from "@/views/StudentCreditsView.vue";
import StudentsSocialGroupsView from "@/views/StudentsSocialGroupsView.vue";
import StudentSocialGroupsView from "@/views/StudentSocialGroupsView.vue";
import StudentsSocialPaymentView from "@/views/StudentsSocialPaymentView.vue";
import StudentSocialPaymentView from "@/views/StudentSocialPaymentView.vue";
import StudentsTrainingDurationView from "@/views/StudentsTrainingDurationView.vue";
import StudentTrainingDurationView from "@/views/StudentTrainingDurationView.vue";
import ProfessionsForeignAmountsView from "@/views/dictionary/ProfessionsForeignAmountsView.vue";
import ProfessionForeignAmountsView from "@/views/dictionary/ProfessionForeignAmountsView.vue";
import StudentsMarinePracticeView from "@/views/StudentsMarinePracticeView.vue";
import StudentMarinePracticeView from "@/views/StudentMarinePracticeView.vue";
import StudentsFlightPracticeView from "@/views/StudentsFlightPracticeView.vue";
import StudentFlightPracticeView from "@/views/StudentFlightPracticeView.vue";
import ReportsView from "@/views/ReportsView.vue";
import MilitaryStudentsView from "@/views/MilitaryStudentsView.vue";
import MilitaryStudentView from "@/views/MilitaryStudentView.vue";
import StudentsGrantsNutritionView from "@/views/StudentsGrantsNutritionView.vue";
import StudentGrantsNutritionView from "@/views/StudentGrantsNutritionView.vue";
import ReportView from "@/views/ReportView.vue";
import EsfInvoiceReconciliationView from "@/views/EsfInvoiceReconciliationView.vue";
import ActAcceptanceView from "@/views/ActAcceptanceView.vue";
import ActReconciliationView from "@/views/ActReconciliationView.vue";
import ReportsOneCView from "@/views/ReportsOneCView.vue";
import EcoPaymentView from "@/views/EcoPaymentView.vue";
import EcoPaymentEditView from "@/views/EcoPaymentEditView.vue";
import AdvanceDeductionsView from "@/views/AdvanceDeductionsView.vue";
import Reports1CourseView from "@/views/Reports1CourseView.vue";
import SummarySocialReportsView from "@/views/SummarySocialReportsView.vue";
import SummaryReportsView from "@/views/SummaryReportsView.vue";
import ProfessionDirectionsView from "@/views/dictionary/ProfessionDirectionsView.vue";
import ProfessionDirectionView from "@/views/dictionary/ProfessionDirectionView.vue";
import EduAreasView from "@/views/dictionary/EduAreasView.vue";
import EduAreaView from "@/views/dictionary/EduAreaView.vue";
import IntergovExpensesView from "@/views/IntergovExpensesView.vue";
import IntergovExpensesEditView from "@/views/IntergovExpensesEditView.vue";
import UETreatmentBenefitView from "@/views/expenses/treatmentBenefit/UETreatmentBenefitView.vue";
import UETreatmentBenefitEditView from "@/views/expenses/treatmentBenefit/UETreatmentBenefitEditView.vue";
import ExpensesSalaryBonusListView from "@/views/ExpensesSalaryBonusListView.vue";
import SummaryCalculatedView from "@/views/SummaryCalculatedView.vue";
import ExpensesSalaryBonusEditView from "@/views/ExpensesSalaryBonusEditView.vue";
import UeExpensesListView from "@/views/UeExpensesListView.vue";
import UeExpensesEditView from "@/views/UeExpensesEditView.vue";
import UEInsuranceWorkerListView from "@/views/expenses/insuranceWorker/UEInsuranceWorkerListView.vue";
import UEInsuranceWorkerEditView from "@/views/expenses/insuranceWorker/UEInsuranceWorkerEditView.vue";
import UENutritionListView from "@/views/expenses/nutrition/UENutritionListView.vue";
import UENutritionEditView from "@/views/expenses/nutrition/UENutritionEditView.vue";
import UEWaterEditView from "@/views/expenses/water/UEWaterEditView.vue";
import UEWaterListView from "@/views/expenses/water/UEWaterListView.vue";
import UEWasteEditView from "@/views/expenses/waste/UEWasteEditView.vue";
import UEWasteListView from "@/views/expenses/waste/UEWasteListView.vue";
import UEInsuranceTransferEditView from "@/views/expenses/insuranceTransfer/UEInsuranceTransferEditView.vue";
import UEInsuranceTransferListView from "@/views/expenses/insuranceTransfer/UEInsuranceTransferListView.vue";
import UEInsuranceTransportEditView from "@/views/expenses/insuranceTransport/UEInsuranceTransportEditView.vue";
import UEInsuranceTransportListView from "@/views/expenses/insuranceTransport/UEInsuranceTransportListView.vue";
import UETransportEditView from "@/views/expenses/transport/UETransportEditView.vue";
import UETransportListView from "@/views/expenses/transport/UETransportListView.vue";
import UECommunicationsEditView from "@/views/expenses/communications/UECommunicationsEditView.vue";
import UECommunicationsListView from "@/views/expenses/communications/UECommunicationsListView.vue";
import UEResearchEditView from "@/views/expenses/research/UEResearchEditView.vue";
import UEResearchListView from "@/views/expenses/research/UEResearchListView.vue";
import UEConsultingEditView from "@/views/expenses/consulting/UEConsultingEditView.vue";
import UEConsultingListView from "@/views/expenses/consulting/UEConsultingListView.vue";
import UEImageEditView from "@/views/expenses/image/UEImageEditView.vue";
import UEImageListView from "@/views/expenses/image/UEImageListView.vue";
import UEWriteOffEditView from "@/views/expenses/writeoff/UEWriteOffEditView.vue";
import UEWriteOffListView from "@/views/expenses/writeoff/UEWriteOffListView.vue";
import UEDepreciationEditView from "@/views/expenses/depreciation/UEDepreciationEditView.vue";
import UEDepreciationListView from "@/views/expenses/depreciation/UEDepreciationListView.vue";
import UETaxEditView from "@/views/expenses/tax/UETaxEditView.vue";
import UETaxListView from "@/views/expenses/tax/UETaxListView.vue";
import UECentralHeatingListView from "@/views/expenses/centralHeating/UECentralHeatingListView.vue";
import UECentralHeatingEditView from "@/views/expenses/centralHeating/UECentralHeatingEditView.vue";
import UEElectricityEditView from "@/views/expenses/eletricity/UEElectricityEditView.vue";
import UEElectricityListView from "@/views/expenses/eletricity/UEElectricityListView.vue";
import UEWaterHeatingListView from "@/views/expenses/water-heating/UEWaterHeatingListView.vue";
import UEWaterHeatingEditView from "@/views/expenses/water-heating/UEWaterHeatingEditView.vue";
import UEWasteWaterListView from "@/views/expenses/wasteWater/UEWasteWaterListView.vue";
import UEWasteWaterEditView from "@/views/expenses/wasteWater/UEWasteWaterEditView.vue";

import UeGsmListView from "@/views/expenses/gsm/UeGsmListView.vue";
import UeGsmEditView from "@/views/expenses/gsm/UeGsmEditView.vue";
import UeCoalDtListView from "@/views/expenses/coal/UeCoalDtListView.vue";
import UeCoalDtEditView from "@/views/expenses/coal/UeCoalDtEditView.vue";
import UeMaterialsListView from "@/views/expenses/materials/UeMaterialsListView.vue";
import UeMaterialsEditView from "@/views/expenses/materials/UeMaterialsEditView.vue";
import UeItListView from "@/views/expenses/it/UeItListView.vue";
import UeItEditView from "@/views/expenses/it/UeItEditView.vue";
import UeStudentsListView from "@/views/expenses/students/UeStudentsListView.vue";
import UeStudentsEditView from "@/views/expenses/students/UeStudentsEditView.vue";
import UeTripsLocalListView from "@/views/expenses/tripslocal/UeTripsLocalListView.vue";
import UeTripsLocalEditView from "@/views/expenses/tripslocal/UeTripsLocalEditView.vue";
import UeTripsForeignListView from "@/views/expenses/tripsforeign/UeTripsForeignListView.vue";
import UeTripsForeignEditView from "@/views/expenses/tripsforeign/UeTripsForeignEditView.vue";
import UeLoansListView from "@/views/expenses/loans/UeLoansListView.vue";
import UeLoansEditView from "@/views/expenses/loans/UeLoansEditView.vue";
import UESocialHelpListView from "@/views/expenses/socialHelp/UESocialHelpListView.vue";
import UESocialHelpEditView from "@/views/expenses/socialHelp/UESocialHelpEditView.vue";
import UEOtherGphListView from "@/views/expenses/otherGph/UEOtherGphListView.vue";
import UEOtherGphEditView from "@/views/expenses/otherGph/UEOtherGphEditView.vue";
import UEInternationalListView from "@/views/expenses/international/UEInternationalListView.vue";
import UEInternationalEditView from "@/views/expenses/international/UEInternationalEditView.vue";
import UEBuildingContentEditView from "@/views/expenses/buildingContent/UEBuildingContentEditView.vue";
import UEBuildingContentListView from "@/views/expenses/buildingContent/UEBuildingContentListView.vue";
import UEContingentListView from "@/views/expenses/contingent/UEContingentListView.vue";
import UEContingentEditView from "@/views/expenses/contingent/UEContingentEditView.vue";
import EventsView from "@/views/EventsView.vue";

const adminRoles: string[] = authService.getAdminRoles();
const managerRoles: string[] = authService.getManagerRoles();
const accountantRoles: string[] = authService.getAccountantRoles();
const universityManagerRoles: string[] = authService.getUniversityManagerRoles();
const universityRectorRoles: string[] = authService.getUniversityRectorRoles();
const auditRoles: string[] = authService.getAuditRoles();
const adminReadOnlyRoles: string[] = authService.getAdminReadOnlyRoles();

const routes = [
    {
        path: "/",
        component: HomeView,
        redirect: "/welcome",
        meta: {requiresAuth: false, roles: []},
        children: [
            {
                path: "/welcome",
                name: "Welcome",
                component: WelcomeView,
                meta: {requiresAuth: true, roles: []},
            },
            {
                path: "/settings",
                name: "Settings",
                component: SettingsView,
                meta: {requiresAuth: true, roles: adminRoles},
            },
            {
                path: "/dictionaries",
                name: "Dictionaries",
                component: DictionariesView,
                meta: {requiresAuth: true, roles: adminRoles},
            },
            {
                path: "/citizenships",
                name: "Citizenships",
                component: CitizenshipsView,
                meta: {requiresAuth: true, roles: adminRoles},
            },
            {
                path: "/degrees",
                name: "Degrees",
                component: DegreesView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/degrees/:id",
                name: "Degree",
                component: DegreeView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/regions",
                name: "Regions",
                component: RegionsView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/regions/:id",
                name: "Region",
                component: RegionView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/universities",
                name: "Universities",
                component: UniversitiesView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/universities/:universityId",
                name: "University",
                component: UniversityView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/professions",
                name: "Professions",
                component: ProfessionsView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/professions/:uuid",
                name: "Profession",
                component: ProfessionView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/professions-cost",
                name: "ProfessionsCost",
                component: ProfessionsCostView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/professions-cost/:uuid",
                name: "ProfessionCost",
                component: ProfessionCostView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/professions-foreign-amounts",
                name: "ProfessionsForeignAmounts",
                component: ProfessionsForeignAmountsView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/professions-foreign-amounts/:uuid",
                name: "ProfessionForeignAmounts",
                component: ProfessionForeignAmountsView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/dict/profession-directions",
                name: "ProfessionDirectionsView",
                component: ProfessionDirectionsView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/dict/profession-directions/:uuid",
                name: "ProfessionDirectionView",
                component: ProfessionDirectionView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/dict/edu-areas",
                name: "EduAreasView",
                component: EduAreasView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/dict/edu-areas/:uuid",
                name: "EduAreaView",
                component: EduAreaView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/users",
                name: "Users",
                component: UsersView,
                meta: {requiresAuth: true, roles: managerRoles}
            },
            {
                path: "/users/:uuid",
                name: "User",
                component: UserView,
                meta: {requiresAuth: true, roles: managerRoles}
            },
            {
                path: "/students",
                name: "Students",
                component: StudentsView,
                meta: {requiresAuth: true, roles: managerRoles}
            },
            {
                path: "/students/:uuid",
                name: "Student",
                component: StudentView,
                meta: {requiresAuth: true, roles: managerRoles}
            },
            {
                path: "/student-credits",
                name: "StudentsCredits",
                component: StudentsCreditsView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/student-credits/:uuid",
                name: "StudentCredits",
                component: StudentCreditsView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/students-social-groups",
                name: "StudentsSocialGroups",
                component: StudentsSocialGroupsView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/students-social-groups/:uuid",
                name: "StudentSocialGroups",
                component: StudentSocialGroupsView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/students-grants-nutrition",
                name: "StudentsGrantsNutrition",
                component: StudentsGrantsNutritionView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/students-grants-nutrition/:uuid",
                name: "StudentGrantsNutrition",
                component: StudentGrantsNutritionView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/students-marine-practice",
                name: "StudentsMarinePractice",
                component: StudentsMarinePracticeView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/students-marine-practice/:uuid",
                name: "StudentMarinePractice",
                component: StudentMarinePracticeView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/students-flight-practice",
                name: "StudentFlightPractice",
                component: StudentsFlightPracticeView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/students-flight-practice/:uuid",
                name: "StudentsFlightPractice",
                component: StudentFlightPracticeView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/students-social-payment",
                name: "StudentsSocialPayment",
                component: StudentsSocialPaymentView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/students-social-payment/:uuid",
                name: "StudentSocialPayment",
                component: StudentSocialPaymentView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/student-training-duration",
                name: "StudentsTrainingDuration",
                component: StudentsTrainingDurationView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/student-training-duration/:uuid",
                name: "StudentTrainingDuration",
                component: StudentTrainingDurationView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/acts/reconciliation",
                name: "ActReconciliation",
                component: ActReconciliationView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles]}
            },
            {
                path: "/acts/acceptance",
                name: "ActAcceptance",
                component: ActAcceptanceView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles]}
            },
            {
                path: "/invoice/reconciliation",
                name: "EsfInvoiceReconciliation",
                component: EsfInvoiceReconciliationView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...accountantRoles]}
            },
            {
                path: "/reports",
                name: "Reports",
                component: ReportsView,
                meta: {requiresAuth: true, roles: [...universityManagerRoles, ...universityRectorRoles, ...auditRoles]}
            },
            {
                path: "/reports-1course",
                name: "Reports1Course",
                component: Reports1CourseView,
                meta: {requiresAuth: true, roles: [...universityManagerRoles, ...universityRectorRoles, ...auditRoles]}
            },
            {
                path: "/reports/:uuid",
                name: "Report",
                component: ReportView,
                meta: {requiresAuth: true, roles: [...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/reports-1c",
                name: "ReportsOneC",
                component: ReportsOneCView,
                meta: {requiresAuth: true, roles: [...accountantRoles, ...adminRoles]}
            },
            {
                path: "/summary-social-reports",
                name: "SummarySocialReports",
                component: SummarySocialReportsView,
                meta: {requiresAuth: true, roles: managerRoles}
            },
            {
                path: "/summary-reports",
                name: "SummaryReports",
                component: SummaryReportsView,
                meta: {requiresAuth: true, roles: adminRoles}
            },
            {
                path: "/military-students",
                name: "MilitaryStudents",
                component: MilitaryStudentsView,
                meta: {requiresAuth: true, roles: managerRoles}
            },
            {
                path: "/military-students/:uuid",
                name: "MilitaryStudent",
                component: MilitaryStudentView,
                meta: {requiresAuth: true, roles: managerRoles}
            },
            {
                path: "/eco-payment",
                name: "EcoPayment",
                component: EcoPaymentView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...universityManagerRoles]}
            },
            {
                path: "/eco-payment/:uuid",
                name: "EcoPaymentEdit",
                component: EcoPaymentEditView,
                meta: {requiresAuth: true, roles: universityManagerRoles}
            },
            {
                path: "/advance-deduction",
                name: "AdvanceDeductionsView",
                component: AdvanceDeductionsView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles]}
            },
            {
                path: "/intergov-expenses",
                name: "IntergovExpensesView",
                component: IntergovExpensesView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/intergov-expenses/:uuid",
                name: "IntergovExpensesEditView",
                component: IntergovExpensesEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/treatment-benefit",
                name: "UETreatmentBenefitView",
                component: UETreatmentBenefitView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/treatment-benefit/:uuid",
                name: "UETreatmentBenefitEditView",
                component: UETreatmentBenefitEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/insurance-worker",
                name: "UEInsuranceWorkerListView",
                component: UEInsuranceWorkerListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/insurance-worker/:uuid",
                name: "UEInsuranceWorkerEditView",
                component: UEInsuranceWorkerEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/insurance-transfer",
                name: "UEInsuranceTransferListView",
                component: UEInsuranceTransferListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/insurance-transfer/:uuid",
                name: "UEInsuranceTransferEditView",
                component: UEInsuranceTransferEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/medicines",
                name: "UeMedicinesListView",
                component: () => import("@/views/UeMedicinesListView.vue"),
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/medicines/:uuid",
                name: "UeMedicinesEditView",
                component: () => import("@/views/UeMedicinesEditView.vue"),
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },

            {
                path: "/expenses/insurance-transport",
                name: "UEInsuranceTransportListView",
                component: UEInsuranceTransportListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/insurance-transport/:uuid",
                name: "UEInsuranceTransportEditView",
                component: UEInsuranceTransportEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/nutrition",
                name: "UENutritionListView",
                component: UENutritionListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/nutrition/:uuid",
                name: "UENutritionEditView",
                component: UENutritionEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                    path: "/expenses/water",
                    name: "UEWaterListView",
                    component: UEWaterListView,
                    meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/water/:uuid",
                name: "UEWaterEditView",
                component: UEWaterEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                    path: "/expenses/central-heating",
                    name: "UECentralHeatingListView",
                    component: UECentralHeatingListView,
                    meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/central-heating/:uuid",
                name: "UECentralHeatingEditView",
                component: UECentralHeatingEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/electricity",
                name: "UEElectricityListView",
                component: UEElectricityListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/electricity/:uuid",
                name: "UEElectricityEditView",
                component: UEElectricityEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/water-heating",
                name: "UEWaterHeatingListView",
                component: UEWaterHeatingListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
          {
                path: "/expenses/water-heating/:uuid",
                name: "UEWaterHeatingEditView",
                component: UEWaterHeatingEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
         {
                path: "/expenses/wastewater",
                name: "UEWasteWaterListView",
                component: UEWasteWaterListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/wastewater/:uuid",
                name: "UEWasteWaterEditView",
                component: UEWasteWaterEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/waste",
                name: "UEWasteListView",
                component: UEWasteListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/waste/:uuid",
                name: "UEWasteEditView",
                component: UEWasteEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/transport",
                name: "UETransportListView",
                component: UETransportListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/transport/:uuid",
                name: "UETransportEditView",
                component: UETransportEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/communications",
                name: "UECommunicationsListView",
                component: UECommunicationsListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/communications/:uuid",
                name: "UECommunicationsEditView",
                component: UECommunicationsEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/research",
                name: "UEResearchListView",
                component: UEResearchListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/research/:uuid",
                name: "UEResearchEditView",
                component: UEResearchEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/consulting",
                name: "UEConsultingListView",
                component: UEConsultingListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/consulting/:uuid",
                name: "UEConsultingEditView",
                component: UEConsultingEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/image",
                name: "UEImageListView",
                component: UEImageListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/image/:uuid",
                name: "UEImageEditView",
                component: UEImageEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/writeoff",
                name: "UEWriteOffListView",
                component: UEWriteOffListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/writeoff/:uuid",
                name: "UEWriteOffEditView",
                component: UEWriteOffEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/depreciation",
                name: "UEDepreciationListView",
                component: UEDepreciationListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/depreciation/:uuid",
                name: "UEDepreciationEditView",
                component: UEDepreciationEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/tax",
                name: "UETaxListView",
                component: UETaxListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/tax/:uuid",
                name: "UETaxEditView",
                component: UETaxEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/salary-bonus",
                name: "ExpensesSalaryBonusList",
                component: ExpensesSalaryBonusListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/summary-calculated",
                name: "SummaryCalculated",
                component: SummaryCalculatedView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles, ...accountantRoles, ...auditRoles]}
            },
            {
                path: "/expenses/summary-vuz-svod",
                name: "SummaryVuzSvod",
                component: SummaryVuzSvodView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles, ...accountantRoles, ...auditRoles]}
            },
            {
                path: "/expenses/salary-bonus/:uuid",
                name: "ExpensesSalaryBonusEdit",
                component: ExpensesSalaryBonusEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/ue-opvr",
                name: "UeOpvrList",
                component: UeExpensesListView,
                props: { expenseType: 'OPVR', pageTitle: 'ОПВР', routePrefix: 'expenses/ue-opvr' },
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/ue-opvr/:uuid",
                name: "UeOpvrEdit",
                component: UeExpensesEditView,
                props: { expenseType: 'OPVR', pageTitle: 'ОПВР' },
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/ue-social-tax",
                name: "UeSocialTaxList",
                component: UeExpensesListView,
                props: { expenseType: 'SOCIAL_TAX', pageTitle: 'Социальный налог', routePrefix: 'expenses/ue-social-tax' },
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/ue-social-tax/:uuid",
                name: "UeSocialTaxEdit",
                component: UeExpensesEditView,
                props: { expenseType: 'SOCIAL_TAX', pageTitle: 'Социальный налог' },
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/ue-social-deduction",
                name: "UeSocialDeductionList",
                component: UeExpensesListView,
                props: { expenseType: 'SOCIAL_DEDUCTION', pageTitle: 'Социальные отчисления', routePrefix: 'expenses/ue-social-deduction' },
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/ue-social-deduction/:uuid",
                name: "UeSocialDeductionEdit",
                component: UeExpensesEditView,
                props: { expenseType: 'SOCIAL_DEDUCTION', pageTitle: 'Социальные отчисления' },
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/ue-osms",
                name: "UeOsmsList",
                component: UeExpensesListView,
                props: { expenseType: 'OSMS', pageTitle: 'ВОСМС', routePrefix: 'expenses/ue-osms' },
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/ue-osms/:uuid",
                name: "UeOsmsEdit",
                component: UeExpensesEditView,
                props: { expenseType: 'OSMS', pageTitle: 'ВОСМС' },
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/gsm",
                name: "UeGsmListView",
                component: UeGsmListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/gsm/:uuid",
                name: "UeGsmEditView",
                component: UeGsmEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/coal",
                name: "UeCoalDtListView",
                component: UeCoalDtListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/coal/:uuid",
                name: "UeCoalDtEditView",
                component: UeCoalDtEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/students",
                name: "UeExpensesStudentsListView",
                component: UeStudentsListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/students/:uuid",
                name: "UeExpensesStudentsEditView",
                component: UeStudentsEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/trips-local",
                name: "UeTripsLocalListView",
                component: UeTripsLocalListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/trips-local/:uuid",
                name: "UeTripsLocalEditView",
                component: UeTripsLocalEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/trips-foreign",
                name: "UeTripsForeignListView",
                component: UeTripsForeignListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/trips-foreign/:uuid",
                name: "UeTripsForeignEditView",
                component: UeTripsForeignEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/loans",
                name: "UeLoansListView",
                component: UeLoansListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/loans/:uuid",
                name: "UeLoansEditView",
                component: UeLoansEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/materials",
                name: "UeMaterialsListView",
                component: UeMaterialsListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/materials/:uuid",
                name: "UeMaterialsEditView",
                component: UeMaterialsEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/it",
                name: "UeItListView",
                component: UeItListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/it/:uuid",
                name: "UeItEditView",
                component: UeItEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/social-help",
                name: "UESocialHelpListView",
                component: UESocialHelpListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/social-help/:uuid",
                name: "UESocialHelpEditView",
                component: UESocialHelpEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/other-gph",
                name: "UEOtherGphListView",
                component: UEOtherGphListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/other-gph/:uuid",
                name: "UEOtherGphEditView",
                component: UEOtherGphEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/international",
                name: "UEInternationalListView",
                component: UEInternationalListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/international/:uuid",
                name: "UEInternationalEditView",
                component: UEInternationalEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/building-content",
                name: "UEBuildingContentListView",
                component: UEBuildingContentListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/building-content/:uuid",
                name: "UEBuildingContentEditView",
                component: UEBuildingContentEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/contingent",
                name: "UEContingentListView",
                component: UEContingentListView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/expenses/contingent/:uuid",
                name: "UEContingentEditView",
                component: UEContingentEditView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles, ...universityRectorRoles]}
            },
            {
                path: "/events",
                name: "EventsView",
                component: EventsView,
                meta: {requiresAuth: true, roles: [...managerRoles, ...adminRoles, ...adminReadOnlyRoles]}
            },
        ],
    },
    {
        path: "/login",
        name: "Login",
        component: LoginView,
        meta: {requiresAuth: false},
    },
    {
        path: '/access-denied',
        name: 'AccessDenied',
        component: AccessDenied,
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const isAuthenticated = !!authService.getAccessToken();

    if (
        to.matched.some((record) => record.meta.requiresAuth) &&
        !isAuthenticated
    ) {
        next({path: "/login"});
    } else if (to.path === "/login" && isAuthenticated) {
        next({path: "/"});
    } else {
        next();
    }
});

export default router;
